<template>
  <div class="footer">
    <div class="wrap">
      <div class="top fiex">
        <div class="t1 f-14 fiex1">
          <dl class="cf">
            <dd class="fl">
              <ul>
                <li class="f-18">
                  <a href="#/film/index">{{ lanuage("10152", "Movies") }}</a>
                </li>
                <li>
                  <a href="#/film/index">{{
                    lanuage("10000", "Hot showing")
                    }}</a>
                </li>
                <li>
                  <a href="#/film/index?type=2">{{
                    lanuage("10003", "Coming soon")
                    }}</a>
                </li>
              </ul>
            </dd>

            <dd class="fl" v-for="(v,i) in menu" :key="i" v-if="v.children.length && v.code!=5">
              <ul>
                <li class="f-18">
                  <a v-if="v.code==2" href="#/experience/index">{{v.name}}</a>
                  <a v-if="v.code==1" href="#/other/activity">{{v.name}}</a>
                  <a v-if="v.code==3" href="#/event/index">{{v.name}}</a>
                  <a v-if="v.code==4" href="javascript:;">{{v.name}}</a>
                </li>
                <li v-for="(vv,ii) in v.children" :key="ii">
                  <template v-if="vv.code!=405">
                    <a v-if="vv.code==101 || vv.code==102"  :href="'#/other/activity?id='+vv.code" >{{vv.name}}</a>
                    <a v-else  href="javascript:;" @click="goDetail(v.code,vv.code)">{{vv.name}}</a>
                  </template>
                  <template v-else>
                    <a href="#/other/faq" >{{vv.name}}</a>
                  </template>
                </li>

              </ul>
            </dd>

            <dd class="fl" >
              <ul>
                <li class="f-18">
                  <a href="#/other/activity">{{
                    lanuage("10175", "Follow us")
                    }}</a>
                </li>
              </ul>
              <div class="tt2">
                <a href="https://www.facebook.com/dadicinema" target="_blank" ><img src="../../../assets/images/foot1.png" /></a>
                <a href="https://www.instagram.com/dadicinema_my/" target="_blank"><img src="../../../assets/images/foot2.png" /></a>
                <!-- <a href="#"><img src="../../../assets/images/foot3.png" /></a> -->
              </div>
            </dd>
          </dl>
        </div>
        <div class="t3 fiex" style="justify-content: flex-end">
          <div class="w">
            <div class="f-18">
              {{ lanuage("10312", "Download Our App") }}
            </div>
            <div class="mag-t-30 f-down">
              <p>
                <a href="https://appgallery.huawei.com/app/C104281553" target="_blank"  class="fiex">
                  <img src="../../../assets/images/d1.png" />
                  <span class="mag-l-10">Android {{ lanuage("10159", "Down") }}</span>
                </a>
              </p>
              <p>
                <a href="https://apps.apple.com/app/id1559855311" target="_blank"  class="fiex">
                  <img src="../../../assets/images/d2.png" />
                  <span class="mag-l-10">Apple {{ lanuage("10159", "Down") }}</span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom fiex">
        <div class="fiex1" style="color: #8e8e8e">
          <p class="mag-t-5" v-for="(v,i) in menu" :key="i" v-if="v.code==5">

            <template v-for="(vv,ii) in v.children">
              <a href="javascript:;" @click="goDetail(v.code,vv.code)" :key="ii">{{vv.name}}</a>
              <span class="mag-l-10 mag-r-10" v-if="ii != (v.children.length-1)">|</span>
            </template>

          </p>
          <p style="display: none">
            <span class="mag-r-20">
              {{
              lanuage(
              "10182",
              "Copyright © 2020 DADI DIGITAL CINEMA Corporation, All Rights Reserved Guangdong ICP No. 12010352"
              )
              }}
            </span>
            <a href="#" style="text-decoration: underline">{{
              lanuage("10183", "Design by ce ultimate")
              }}</a>
          </p>
        </div>
        <div class="lg">
          <a href="#"><img style="width: 200px; height: auto" src="../../../assets/images/logo.png" /></a>
        </div>
      </div>
      
    </div>


  </div>
</template>
<script>

  import { foot } from "@/api/home/home";
  import { newslist } from "@/api/activity";
  export default {
    name: "foots",
    data() {
      return {
        menu: {},
      };
    },
    mounted() {
      foot({
        method: "get",
        data: {},
      }).then((res) => {
        //console.log(res)

        if (res.code === 200) {
          this.menu = res.data;
        }
      });
    },
    activated() { },
    computed: {},
    methods: {
      mainShare(app) {
        let url = window.location.href;
        let title = document.title;
        this.sharePage(app, url, title);
      },

      goDetail(aa, bb) {
        newslist({
          method: "get",
          data: {
            first: aa,
            second: bb,
            pageNum: 1,
            pageSize: 2,
            isApp: 0,
          },
        }).then((res) => {
          if (res.code === 200) {
            // 对数据进行一些处理
            if (res.data.records.length == 1) {

              this.$router.push({
                path: "/other/activity_detail",
                query: { id: res.data.records[0].id},
              });

            } else {

            }

          }
        });


      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/global/foots/index.vue